import { render } from "./clinic-appointment-history.vue?vue&type=template&id=184e0e58&scoped=true"
import script from "./clinic-appointment-history.vue?vue&type=script&lang=js"
export * from "./clinic-appointment-history.vue?vue&type=script&lang=js"

import "./clinic-appointment-history.vue?vue&type=style&index=0&id=184e0e58&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-184e0e58"]])

export default __exports__